import { render, staticRenderFns } from "./FreightTableTabFilterModal.vue?vue&type=template&id=1f8047d1&scoped=true"
import script from "./FreightTableTabFilterModal.vue?vue&type=script&lang=js"
export * from "./FreightTableTabFilterModal.vue?vue&type=script&lang=js"
import style0 from "./FreightTableTabFilterModal.vue?vue&type=style&index=0&id=1f8047d1&prod&scoped=true&lang=less"
import style1 from "./FreightTableTabFilterModal.vue?vue&type=style&index=1&id=1f8047d1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8047d1",
  null
  
)

export default component.exports